<script setup lang="ts">
export type ListIconsItem = {
    icon: Icon
    title: string
}

export interface ListIconsProps {
    data: ListIconsItem[]
}

const props = defineProps<ListIconsProps>()
</script>

<template>
  <div class="p-5 px-md-0 pt-md-10 pb-md-8 rounded list-icons-bg">
    <ul class="row">
      <li
        v-for="(item, index) in props.data"
        :key="index"
        :class="{ 'mb-9 mb-md-0': index < props.data.length - 1 }"
        class="text-md-center col-12 col-md-4 d-md-block d-flex align-items-center"
      >
        <img
          width="28"
          height="28"
          :src="item.icon.path"
          alt=""
          loading="lazy"
          decoding="async"
          class="mb-md-4 d-block mx-md-auto list-icons-icon"
        >
        <p class="zeta mb-0 ms-5 ms-md-0">
          {{ item.title }}
        </p>
      </li>
    </ul>
  </div>
</template>

<style>
@import './ListIcons.vars.scss';
</style>
<style scoped lang="scss">
@import './ListIcons.scss';
</style>
